<template>
  <div class="home_wrap">
    <!-- <div class="red_top_bg">
      <van-row>
        <van-col span="7"
          ><div style="display: inline-flex">
            <img
              class="logoImg"
              :src="require('../images/home/LOGO.png')"
            />
            <img
              class="logoBanner"
              :src="require('../images/home/AFM.png')"
            />
          </div>
        </van-col>
        <van-col span="13">
          <div class="search_box" @click="$router.push('/search')">
            <input
              type="text"
              readonly
              :placeholder="$t('index.search')"
              class="search_inp"
            />
            <van-icon name="search" color="#ffffff" size="20" />
          </div>
        </van-col>
        <van-col span="4" style="display: inline-flex">
          <div class="language" @click="$router.push('/language')">
            <img :src="require('../images/language/' + lang + '.png')" />
          </div>
          <div class="msg" @click="$router.push('/notice')">
            <img src="../images/home/BELL.png" />
          </div>
        </van-col>
      </van-row>
    </div> -->
    <van-swipe
      :autoplay="2500"
      class="swiper-container"
      @change="onChange"
      indicator-color="white"
    >
      <van-swipe-item v-for="(image, index) in data.banner" :key="index">
        <router-link :to="image.url">
          <img :src="image[lang + '_image']" />
        </router-link>
      </van-swipe-item>
      <!-- <van-swipe-item>
        <img src="../images/remove/movie5.png" style="width: 100%" />
      </van-swipe-item>
      <img src="../images/remove/movie5.png" style="width: 100%" />
      <van-swipe-item></van-swipe-item> -->
    </van-swipe>
    <Header></Header>
    <div class="movieContainer" v-for="item in data.item1.list" :key="item.id">
      <van-row>
        <van-col span="24">
          <img :src="item.image" class="movieTopImg" />
        </van-col>
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="12"
          ><p class="usdtAmt">
            {{
              (parseFloat(item.total) - parseFloat(item.investment)).toFixed(2)
            }}
            USDT {{ $t("home.more") }}
          </p>
          <p></p
        ></van-col>
        <van-col span="12" class="remainDays"
          >{{ $t("home.remain") }} {{ item.day }} {{ $t("home.days") }}</van-col
        >
      </van-row>

      <van-row id="progressBar" style="padding-top: 15px">
        <van-progress
          :percentage="item.percent"
          color="#d4462e"
          stroke-width="28"
        />
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="24">
          <div style="display: flex; align-items: center">
            <img
              src="../images/home/movie.png"
              style="height: 70px; width: auto"
            />
            <div>
              <p class="movieName">{{ item[lang] }}</p>
              <div class="startSection">
                <star-rating
                  :star-size="20"
                  :animate="true"
                  :read-only="true"
                  :increment="0.01"
                  :rating="parseFloat(item.rate)"
                />
                <img
                  @click="favorite(item)"
                  :src="
                    item.isFav
                      ? require('@/views/images/home/favourite.png')
                      : require('@/views/images/home/unfavourite.png')
                  "
                  style="height: 20px; width: auto; margin-left: 10px"
                />
              </div>
            </div>
          </div>
          <p class="movieDetail">{{ item["desc_" + lang] }}</p>
        </van-col>
      </van-row>
      <!-- <van-divider
        :style="{
          borderColor: '#ffffff',
          padding: '10px 25px 0px',
          margin: '0px',
        }"
      >
      </van-divider> -->
      <!-- <van-row style="padding: 10px 25px 0px">
        <van-row style="align-items: center; display: flex">
          <van-col span="14">
            <div style="align-items: center; display: flex">
              <img
                src="../images/home/arrow_left.png"
                style="height: 15px; width: auto"
              />
              <p class="movieInfoItem">{{ $t("index.investDuration") }}:</p>
            </div>
          </van-col>
          <van-col span="10">
            <p class="movieInfoItem">{{ item.invest_duration }} {{ item.invest_duration > 1 ? $t("home.days") : $t("rewardRulesTabOne.day") }}</p>
          </van-col>
        </van-row>
        <van-row
          style="padding: 10px 0px 0px; align-items: center; display: flex"
        >
          <van-col span="14">
            <div style="align-items: center; display: flex">
              <img
                src="../images/home/arrow_left.png"
                style="height: 15px; width: auto"
              />
              <p class="movieInfoItem">{{ $t("events.returnInvestPerc") }}:</p>
            </div>
          </van-col>
          <van-col span="10">
            <p class="movieInfoItem">{{ item.interest_rate }}%</p>
          </van-col>
        </van-row>
        <van-row
          style="padding: 10px 0px 0px; align-items: center; display: flex"
        >
          <van-col span="14">
            <div style="align-items: center; display: flex">
              <img
                src="../images/home/arrow_left.png"
                style="height: 15px; width: auto"
              />
              <p class="movieInfoItem">{{ $t("index.minInvest") }}:</p>
            </div>
          </van-col>
          <van-col span="10">
            <p class="movieInfoItem">${{ item.min }}</p>
          </van-col>
        </van-row>
      </van-row> -->

      <van-row style="padding: 20px 0px">
        <div
          style="align-items: center; display: flex; justify-content: center"
        >
          <img
            src="../images/home/green_arrow_left.png"
            style="height: 40px; width: auto"
          />
          <router-link :to="'/moviedetail/' + item.id">
            <div class="InfoDetailBtnBg">
              <p class="infoDetailsP">{{ $t("home.detailInfo") }}</p>
            </div>
          </router-link>
          <img
            src="../images/home/green_arrow_right.png"
            style="height: 40px; width: auto"
          />
        </div>
      </van-row>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";
import Footer from "../../components/footer";
import Header from "../../components/header";
import StarRating from "vue-star-rating";
import moment from "moment";
import {
  Swipe,
  SwipeItem,
  Icon,
  Progress,
  Dialog,
  Field,
  Col,
  Row,
  Divider,
  Toast,
} from "vant";

Vue.use(Icon)
  .use(Progress)
  .use(Dialog)
  .use(Field)
  .use(Row)
  .use(Col)
  .use(Divider);

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    Footer,
    Header,
    StarRating,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      show_kefu: false,
      msg_show: true,
      loading: false,
      icon: [],
      data: {
        item1: { list: [] },
      },
      show_img: false,
      show_tz: false,
      show_tc: false,
      tc_content: "",
      number: "",
      sku: [],
    };
  },
  // created() {
  //   this.$parent.footer("index");
  // },
  mounted() {
    this.start();
    //代理标识设置
    if (this.$router.history.current.query.agent) {
      localStorage.setItem("agent", this.$router.history.current.query.agent);
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
  },
  methods: {
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    hideDown() {
      this.show_img = false;
      this.$store.commit("setShowAdvert", false);
    },
    start() {
      Fetch("/index/int").then((r) => {
        this.data = r.data;
        this.loading = true;
        if (r.data.popup.show == 1) {
          this.tc_content = r.data.popup.content;
          this.show_tc = true;
        }
      });
    },
    onChange(index) {},
    buy(item) {
      this.sku = item;
      this.show_tz = true;
    },
    confirm() {
      if (!this.number) {
        this.$toast(this.$t("item.inputAmount"));
        return false;
      }
      Fetch("/index/item_apply", {
        id: this.sku.id,
        money: this.number,
      })
        .then((r) => {
          this.$router.push("/order");
        })
        .catch((err) => {
          this.psd_val = "";
        });
    },
    favorite(item) {
      item.isFav ? this.delFav(item) : this.addFav(item);
    },
    addFav(item) {
      Fetch("/movie/addUserItem", {
        item_id: item.id,
      }).then((r) => {
        if (r.code == 1) {
          item.isFav = true;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    delFav(item) {
      Fetch("/movie/removeUserItem", {
        item_id: item.id,
      }).then((r) => {
        if (r.code == 1) {
          item.isFav = false;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
  padding-bottom: 80px;
}

.swiper-container {
  width: 100%;
  height: 154px;
  // margin-top: 44px;
  background: transparent;

  .van-swipe-item {
    overflow: hidden;
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
  }

  img {
    // border-radius: 6px;
    // margin-left: 2%;
    height: auto;
    width: 100%;
    background-size: cover;
  }
}
.movieContainer {
  padding: 10px;
  border: 1px solid #ffffff;
  border-radius: 15px;
  margin: 8px;
}

.movieTopImg {
  object-fit: cover;
  width: 100%;
  height: 200px;
  border-radius: 15px;
  max-height: 450px;
}

.usdtAmt {
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #ffffff;
  padding: 4px;
  border-radius: 5px;
  width: fit-content;
  text-align: center;
  word-break: break-word;
}

.remainDays {
  color: #ffffff;
  font-size: 14px;
  padding: 4px 0px;
  text-align: right;
}

.movieName {
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  word-break: break-word;
}

.movieDetail {
  color: #ffffff;
  font-size: 13px;
  border: 1px solid #ffffff;
  padding: 3px;
  border-radius: 5px;
  width: fit-content;
  text-align: justify;
  margin-top: 4px;
  word-break: break-word;
}

.startSection {
  display: flex;
  align-items: center;
  // justify-content: flex-end;
  margin-top: 5px;
}

.movieInfoItem {
  color: #ffffff;
  font-size: 12px;
  padding-left: 5px;
  word-break: break-word;
}

.InfoDetailBtnBg {
  background: url("../images/home/yellowBtnBg.png");
  background-size: 100% 100%;
}

.infoDetailsP {
  padding: 14px;
  color: #ffffff;
  font-size: 15px;
  word-break: break-word;
  text-align: center;
}
</style>
<style>
#progressBar .van-progress {
  border-radius: 20px;
}

#progressBar .van-progress__pivot {
  background-color: unset !important;
  color: #000000;
  font-size: 14px;
  /* right: 0; */
  font-weight: 700;
  /* left: unset !important; */
}

.startSection .vue-star-rating-rating-text {
  color: #eada3e;
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}
</style>
